// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Mf-z","landingPageVideo":"Nf-z","play":"Of-z","iframeVideo":"Pf-z","playHidden":"Qf-z","fullwidth":"Rf-z"};